/**
 * 0.45.33 - Colours the matches of a search inside its children (a
 * table, for now): the shared search highlight (lib/searchHighlight.js).
 * `display: contents`, so the wrapper adds no box and changes no layout.
 */
import { useRef } from 'react';
import { useSearchHighlight } from '../lib/searchHighlight';

export default function SearchHighlightZone({ query = '', enabled = true, color = null, children }) {
  const ref = useRef(null);
  useSearchHighlight(ref, query, enabled);
  return (
    <div ref={ref}
         style={{ display: 'contents', ...(color ? { '--search-highlight-color': color } : null) }}>
      {children}
    </div>
  );
}
